import Articles from './Articles';
import FeaturedArticles from './FeaturedArticles';
import FilterBar from './FilterBar';
import { BlogArticlesFragmentFragment, FeaturedArticlesFragmentFragment } from '../../__generated__/graphql';
import Section from '../../layout/Section';
import { ContentBlock } from '../types';

// Component Definition
const BlogArticles: ContentBlock<BlogArticlesFragmentFragment> = ({ fragment }) => {
  const contentBlockProps = fragment.blogArticles;

  if (!contentBlockProps) {
    return null;
  }

  const featuredArticles = contentBlockProps.featuredArticles as FeaturedArticlesFragmentFragment[];

  return (
    <>
      <FilterBar />
      <FeaturedArticles featuredArticles={featuredArticles} />
      <Section
        backgroundColor="white"
        id={contentBlockProps.sectionId}
      >
        <Articles featuredArticles={featuredArticles} />
      </Section>
    </>
  );
};

export default BlogArticles;
